<template>
<!-- Social Networks -->
<nav class="icon-social-container">
    <!-- Play Store button -->
    <a href="https://play.google.com/store/apps/dev?id=7607519243151491071" target="_blank"> 
        <img class="icon__social" src="@/assets/navbar/play_store_icon.png" alt="Play Store">
    </a>

    <!-- Github button -->
    <a href="https://github.com/jerffesonj/" target="_blank"> 
        <img class="icon__social" src="@/assets/navbar/github_icon.png" alt="Github">
    </a>

    <!-- Linkedin button -->
    <a href="https://www.linkedin.com/in/jerffesonj/" target="_blank"> 
        <img class="icon__social" src="@/assets/navbar/linkedin_icon.png" alt="Linkedin">
    </a>

    <!-- Itch.io button -->
    <a href="https://jerffesonj.itch.io/" target="_blank"> 
        <img class="icon__social" src="@/assets/navbar/itch_icon.png" alt="itch.io">
    </a>
</nav>
</template>

<style>
.icon-social-container{
    display: flex;
    justify-content: center;
    margin-top: 20px;
    margin-bottom: 20px;
}
.icon__social{
    margin-left: 7px;
    margin-right: 7px;
    transition: transform 0.3s ease;
}
.icon__social:hover{
  transform: scale(1.1)
}
</style>